<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Time_Range"
    :submit="submit"
    :status="status"
  >
  <ValidationObserver ref="validator" v-slot="{}">
    <v-row justify="center">
      <v-col cols="8">
        <v-row>
          <v-col>
            <ValidationProvider
              ref="name"
              rules="required"
              v-slot="{ errors }"
            >
              <v-text-field
                :error-messages="errors"
                v-model="data.name"
                label="Name"
                prepend-inner-icon="fas fa-tag"
                ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="8">
        <v-row>
          <v-col>
            <ValidationProvider ref="hour" rules="required" v-slot="{ errors }">
              <v-menu
                  ref="hour"
                  v-model="menuHourFrom"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  :error-messages="errors"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="data.hour_from"
                      label="Hour from"
                      prepend-icon="fas fa-clock"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-model="data.hour_from"
                    format="24hr"
                    @input="menuHourFrom = false"
                ></v-time-picker>
              </v-menu>
            </ValidationProvider>
          </v-col>

          <v-col>
            <ValidationProvider ref="hour" rules="required" v-slot="{ errors }">
              <v-menu
                  ref="hour"
                  v-model="menuHourTo"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  :error-messages="errors"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="data.hour_to"
                      label="Hour to"
                      prepend-icon="fas fa-clock"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-model="data.hour_to"
                    format="24hr"
                    @input="menuHourTo = false"
                ></v-time-picker>
              </v-menu>
            </ValidationProvider>
          </v-col>
        </v-row>
      </v-col>   
    </v-row>
  </ValidationObserver>
</CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
      })
    },
    data() {
      return {
        storeName: 'Time_range',
        title: "Time Range",
        data: {
          name: "",
          hour_from: null,
          hour_to: null,
        },        
        menuHourFrom: false,
        menuHourTo: false,
      }
    }
  }
</script>
